import React from 'react';
import {
  GoogleOAuthProvider,
  GoogleLogin,
  useGoogleLogin,
  TokenResponse,
} from '@react-oauth/google';
import axios from 'axios';

interface CustomGoogleLoginProps {
  onSuccess: (userInfo: any) => void;
  onFailed: (error: any) => void;
}

const CustomGoogleLogin: React.FC<CustomGoogleLoginProps> = ({ onSuccess, onFailed }) => {
  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      try {
        const userInfo = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        onSuccess(userInfo);
      } catch (error) {
        onFailed(error);
      }
    },
    onError: (errorResponse) => onFailed(errorResponse),
  });

  return (
    <>
      <button
        onClick={(e) => {
          e.preventDefault();
          googleLogin();
        }}
        className='googleBtn w-100'
      >
        <img src="./google.png" alt="google logo" />
        <span>Sign up with Google</span>
      </button>
    </>
  );
};

interface GoogleLoginComponentProps {
  clientId?: string;
  onSuccess: (credentialResponse: any) => void;
  onFailed: (error: any) => void;
  extraClassName?: string;
  isCustom?: boolean;
  icon?: React.ReactNode; 
}

const GoogleLoginComponent: React.FC<GoogleLoginComponentProps> = ({
  clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string,
  onSuccess,
  onFailed,
  extraClassName,
  isCustom = false,
  icon,
  ...rest
}) => {
  return (
    <GoogleOAuthProvider clientId={clientId}>
      {isCustom ? (
        <CustomGoogleLogin onSuccess={onSuccess} onFailed={onFailed} />
      ) : (
        <div className={extraClassName}>
          <GoogleLogin onSuccess={onSuccess} onError={() => onFailed('Login Failed')} {...rest} />
        </div>
      )}
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginComponent;